import { NavLink } from 'react-router-dom';
import { PageLayout } from '@/components';
import styles from './LegalPlaceholder.module.css';

export function MedicalDisclaimer() {
  return (
    <PageLayout plain>
      <article className={styles.article}>
        <NavLink to="/" className={styles.back}>← Terug</NavLink>
        <h1 className={styles.title}>Medische disclaimer</h1>
        <p className={styles.meta}>Versie 1.1 · 26 juni 2026 · Dermalink</p>
        <p className={styles.intro}>
          Lees deze disclaimer voor u Dermalink gebruikt. Door een consultatieaanvraag te starten, bevestigt u dat u deze hebt gelezen en begrepen.
        </p>

        <section className={styles.section}>
          <h2 className={styles.h2}>1. Wat Dermalink is</h2>
          <p className={styles.p}>
            Dermalink is een teleconsultatieplatform waarmee u op een gestructureerde manier een of meerdere foto&apos;s en een klinische vraag bezorgt aan een dermatoloog. De communicatie verloopt asynchroon: u en de arts zijn niet op hetzelfde moment online, de arts bekijkt uw aanvraag en antwoordt op een later tijdstip. Het gaat om medisch advies op afstand, op basis van de informatie en de beelden die u zelf aanlevert.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.h2}>2. Wat Dermalink niet is</h2>
          <ul className={styles.ul}>
            <li>Dermalink is geen vervanging van een fysieke raadpleging wanneer een onderzoek ter plaatse aangewezen is. De arts kan u in het advies steeds doorverwijzen voor een consultatie in de praktijk.</li>
            <li>Dermalink is geen spoeddienst en voorziet geen permanentie: er is geen onmiddellijke of continue opvolging en geen bewaking 24 uur op 24.</li>
            <li>Dermalink geeft geen garantie op een sluitende diagnose. Een beoordeling op afstand heeft inherente beperkingen: de arts kan de huid niet voelen, de beeldkwaliteit kan beperkt zijn en bepaalde aandoeningen vereisen aanvullend onderzoek.</li>
            <li>Dermalink gebruikt geen artificiële intelligentie en stelt zelf geen diagnose. Elk advies komt van een geïdentificeerde, erkende dermatoloog.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2 className={styles.h2}>3. Bij spoed of alarmsignalen</h2>
          <div className={styles.calloutBox}>
            <p className={styles.p}><strong>Gebruik Dermalink niet in een noodsituatie.</strong></p>
            <p className={styles.p}>Bij dringende of ernstige klachten belt u 112 of gaat u rechtstreeks naar een spoedgevallendienst of uw huisarts. U mag niet op een antwoord via Dermalink wachten in een situatie die onmiddellijke zorg vereist.</p>
            <p className={styles.p}>Zoek onmiddellijk dringende hulp bij onder meer: snel uitbreidende of pijnlijke huidletsels met koorts of algemeen ziek zijn, uitgebreide blaarvorming, tekenen van een veralgemeende infectie zoals koorts of snel verslechteren, een allergische reactie met ademhalingsmoeilijkheden of zwelling van het gezicht. Deze opsomming is niet volledig.</p>
            <p className={styles.p}>Twijfelt u? U hoeft zelf niet te kunnen inschatten of het dringend is. Twijfelt u over de ernst of de urgentie, beschouw de situatie dan als dringend en zoek onmiddellijk hulp. Wacht niet op een antwoord via Dermalink.</p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.h2}>4. Beperkingen van teledermatologie</h2>
          <p className={styles.p}>
            Het advies van de arts is gebaseerd op de informatie en de beelden die u aanlevert. Onvolledige, onscherpe of misleidende informatie kan de beoordeling beperken of onmogelijk maken. De arts beslist autonoom of de aangeleverde informatie volstaat voor een advies op afstand, dan wel of een fysiek onderzoek nodig is. Een advies via Dermalink houdt geen continue opvolging in: wanneer uw klachten aanhouden, verergeren of veranderen, neemt u opnieuw contact op of raadpleegt u een arts ter plaatse.
          </p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.h2}>5. Uw verantwoordelijkheid</h2>
          <ul className={styles.ul}>
            <li>U bezorgt correcte, volledige en actuele informatie en kwaliteitsvolle foto&apos;s.</li>
            <li>U volgt het advies en eventuele doorverwijzingen van de arts tijdig op.</li>
            <li>U gebruikt Dermalink niet voor situaties die dringende of fysieke zorg vereisen.</li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2 className={styles.h2}>6. Toestemming</h2>
          <p className={styles.p}>
            Door gebruik te maken van Dermalink erkent u de aard en de beperkingen van de dienst zoals hierboven beschreven, en stemt u in met een beoordeling op afstand. Deze disclaimer maakt integraal deel uit van de Gebruikersovereenkomst van Dermalink en doet geen afbreuk aan uw rechten als patiënt, noch aan de wettelijke verplichtingen van de behandelende arts.
          </p>
        </section>
      </article>
    </PageLayout>
  );
}
